/**
 * Formats a date string or object to 'dd/MM/yyyy HH:mm' in Asia/Jerusalem timezone.
 * @param {string|Date} dateInput - The date to format.
 * @param {string} formatType - The type of format to return ('default', 'date-only', 'time-only', 'datetime-seconds').
 * @returns {string} - The formatted date string.
 */
export const formatDateToJerusalem = (dateInput, formatType = 'default') => {
  if (!dateInput) return '';

  try {
    let date;

    // Handle different date formats or existing Date objects
    if (typeof dateInput === 'string') {
      // Try parsing as ISO string first
      if (dateInput.includes('T') || dateInput.includes('Z')) {
        date = new Date(dateInput);
      } else if (dateInput.includes('-')) {
        // Handle YYYY-MM-DD format
        date = new Date(dateInput);
      } else if (dateInput.includes('/')) {
        // Handle DD/MM/YYYY format
        const parts = dateInput.split(/[/\s:]/);
        // Basic check for DD/MM/YYYY (e.g., 27/10/2023)
        if (parts.length >= 3 && parts[2].length === 4) {
             date = new Date(
              parts[2],      // Year
              parts[1] - 1,  // Month (0-index)
              parts[0],      // Day
              parts[3] || 0, // Hour
              parts[4] || 0, // Minute
              parts[5] || 0  // Second
            );
        } else {
           // Fallback for MM/DD/YYYY or others if likely
           date = new Date(dateInput);
        }
      } else {
        // Fallback for other string formats
        date = new Date(dateInput);
      }
    } else if (dateInput instanceof Date) {
      date = dateInput;
    } else {
      date = new Date(dateInput);
    }

    if (isNaN(date.getTime())) {
      console.warn('Invalid date string:', dateInput);
      return 'Invalid Date';
    }

    // Configure DateTimeFormat options based on formatType
    const options = {
      timeZone: 'Asia/Jerusalem',
      hour12: false,
    };

    switch (formatType) {
      case 'date-only':
        options.year = 'numeric';
        options.month = '2-digit';
        options.day = '2-digit';
        break;
      case 'time-only':
        options.hour = '2-digit';
        options.minute = '2-digit';
        break;
      case 'datetime-seconds':
        options.year = 'numeric';
        options.month = '2-digit';
        options.day = '2-digit';
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.second = '2-digit';
        break;
      case 'default':
      default:
        options.year = 'numeric';
        options.month = '2-digit';
        options.day = '2-digit';
        options.hour = '2-digit';
        options.minute = '2-digit';
        break;
    }

    // Format the date using Intl.DateTimeFormat
    // locale 'en-GB' typically results in dd/mm/yyyy
    const formatted = new Intl.DateTimeFormat('en-GB', options).format(date);
    
    // Remove comma if present (default behaviour of en-GB for datetime is "dd/mm/yyyy, hh:mm")
    return formatted.replace(',', '');

  } catch (error) {
    console.warn('Date formatting error:', error, 'for date:', dateInput);
    return 'Invalid Date';
  }
};
